import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { DropdownMenuItemCreateEvent } from '@/features/events/components/dropdown-menu-item-create-event';
import { DropdownMenuItemCreateNote } from '@/features/notes/components/dropdown-menu-item-create-note';
import { DropdownMenuItemCreateDraft } from '@/features/sales-draft/components/dropdown-menu-item-create-draft';
import { DropdownMenuItemCreateTask } from '@/features/tasks/components/dropdown-menu-item-create-task';
import { useLocale } from '@/lib/hooks/use-locale';
import { PlusIcon } from 'lucide-react';
import * as React from 'react';

export type CreateNewOrderMenuProps = {
    showFullInput?: boolean;
    className?: string;
    onClose?: () => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const CreateNewMenu = React.forwardRef<HTMLInputElement, CreateNewOrderMenuProps>(
    ({ showFullInput = true, onClose = () => {} }, ref) => {
        const { t } = useLocale();
        const [open, setOpen] = React.useState(false);

        const closeMenu = () => {
            setOpen(false);
            onClose();
        };

        return (
            <DropdownMenu open={open} onOpenChange={setOpen}>
                <DropdownMenuTrigger asChild>
                    {showFullInput ? (
                        <Button
                            className="w-full justify-start"
                            variant="ghost"
                            selected={open}
                            onClick={() => setOpen(true)}
                            leftIcon={PlusIcon}
                        >
                            <span>{t('top_navbar__new_actvity')}</span>
                        </Button>
                    ) : (
                        <Button size="icon-s" variant="outline" selected={open} onClick={() => setOpen(true)}>
                            <PlusIcon className="flex h-4 w-4 shrink-0 " />
                        </Button>
                    )}
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" side="right" className="z-9999">
                    <DropdownMenuItemCreateTask links={[]} />
                    <DropdownMenuItemCreateDraft />
                    <DropdownMenuItemCreateEvent analyticsSource="menu" />
                    <DropdownMenuItemCreateNote />
                </DropdownMenuContent>
            </DropdownMenu>
        );
    },
);

CreateNewMenu.displayName = 'CreateNewMenu';

export { CreateNewMenu };
